import React, { Component } from 'react';
import logo from "../../../assets/img/MAXMRJ-Logo-1.png"
import { apiPath } from 'api';
import { generalAuthTokenHeader } from '__helpers/auth-header';
import { userService } from '_services/user.service';

class PreviewSubmittedSurvey extends Component {
  constructor(props) {
    super(props);
    let spinner = document.getElementById("loadingSpinner");
    this.state = {
      spinner: spinner,
      showSurvey: true,
      loading: false,
      submitted: true,
      error: null,
      surveyData: {
        "formResponseId": 802059,
        "submittedAt": "2025-07-17T14:09:49.936",
        "surveyForm": {
          "surveyFormId": 797653,
          "title": "Health Survey-All",
          "description": "Full survey",
          "introText": "",
          "endText": "Thank you for your time!",
          "dpId": 222102,
          "isDefault": false,
          "questions": [
            {
              "questionId": 797726,
              "questionText": "How many medications are you currently prescribed?",
              "required": false,
              "questionOrder": 1,
              "weightage": 0.00,
              "inputTypeId": 766101,
              "inputTypeName": "Short Answer",
              "domainId": 768650,
              "isDefault": false,
              "options": null,
              "answer": {
                "answerId": 802147,
                "questionId": 797726,
                "answerText": "8",
                "hasOption": false,
                "answerOption": []
              }
            },
            {
              "questionId": 797714,
              "questionText": "Please describe any challenges you face when taking your medications.",
              "required": false,
              "questionOrder": 2,
              "weightage": 3.00,
              "inputTypeId": 766102,
              "inputTypeName": "Paragraph",
              "domainId": 768650,
              "isDefault": false,
              "options": null,
              "answer": {
                "answerId": 802148,
                "questionId": 797714,
                "answerText": "No,I don't have",
                "hasOption": false,
                "answerOption": []
              }
            },
            {
              "questionId": 797716,
              "questionText": "Are you currently able to bathe, dress, and feed yourself independently?",
              "required": false,
              "questionOrder": 1,
              "weightage": 2.00,
              "inputTypeId": 766101,
              "inputTypeName": "Short Answer",
              "domainId": 768700,
              "isDefault": false,
              "options": null,
              "answer": {
                "answerId": 802149,
                "questionId": 797716,
                "answerText": "Yes",
                "hasOption": false,
                "answerOption": []
              }
            },
            {
              "questionId": 797717,
              "questionText": "On a scale of 1 to 5, how would you rate your ability to perform daily tasks?",
              "required": false,
              "questionOrder": 2,
              "weightage": 3.00,
              "inputTypeId": 774651,
              "inputTypeName": "Rating",
              "domainId": 768700,
              "isDefault": false,
              "options": [
                {
                  "optionId": 797783,
                  "optionText": "1"
                },
                {
                  "optionId": 797784,
                  "optionText": "2"
                },
                {
                  "optionId": 797785,
                  "optionText": "3"
                },
                {
                  "optionId": 797786,
                  "optionText": "4"
                },
                {
                  "optionId": 797787,
                  "optionText": "5"
                }
              ],
              "answer": {
                "answerId": 802150,
                "questionId": 797717,
                "answerText": null,
                "hasOption": true,
                "answerOption": [
                  {
                    "answerOptionId": 802169,
                    "optionText": "4",
                    "optionId": 797786
                  }
                ]
              }
            },
            {
              "questionId": 797718,
              "questionText": "Have you experienced memory problems since discharge?",
              "required": false,
              "questionOrder": 1,
              "weightage": 2.00,
              "inputTypeId": 766001,
              "inputTypeName": "Multiple Choice",
              "domainId": 768750,
              "isDefault": false,
              "options": [
                {
                  "optionId": 797788,
                  "optionText": "Yes"
                },
                {
                  "optionId": 797789,
                  "optionText": "No"
                },
                {
                  "optionId": 797790,
                  "optionText": "Occasionally"
                }
              ],
              "answer": {
                "answerId": 803151,
                "questionId": 797718,
                "answerText": null,
                "hasOption": true,
                "answerOption": [
                  {
                    "answerOptionId": 802170,
                    "optionText": "Occasionally",
                    "optionId": 797790
                  }
                ]
              }
            },
            {
              "questionId": 797719,
              "questionText": "If Yes, which cognitive difficulties are you experiencing?",
              "required": false,
              "questionOrder": 2,
              "weightage": 2.00,
              "inputTypeId": 766103,
              "inputTypeName": "Checkbox",
              "domainId": 768750,
              "isDefault": false,
              "options": [
                {
                  "optionId": 797791,
                  "optionText": "Memory loss"
                },
                {
                  "optionId": 797792,
                  "optionText": "Difficulty concentrating"
                },
                {
                  "optionId": 797793,
                  "optionText": "Disorientation"
                },
                {
                  "optionId": 797794,
                  "optionText": "Difficulty following conversations"
                }
              ],
              "answer": {
                "answerId": 803152,
                "questionId": 797719,
                "answerText": null,
                "hasOption": true,
                "answerOption": [
                  {
                    "answerOptionId": 802171,
                    "optionText": "Difficulty concentrating",
                    "optionId": 797792
                  },
                  {
                    "answerOptionId": 802172,
                    "optionText": "Difficulty following conversations",
                    "optionId": 797794
                  }
                ]
              }
            },
            {
              "questionId": 797720,
              "questionText": "Do you currently experience any pain or discomfort?",
              "required": false,
              "questionOrder": 1,
              "weightage": 2.00,
              "inputTypeId": 766001,
              "inputTypeName": "Multiple Choice",
              "domainId": 768800,
              "isDefault": false,
              "options": [
                {
                  "optionId": 797795,
                  "optionText": "Yes"
                },
                {
                  "optionId": 797796,
                  "optionText": "No"
                },
                {
                  "optionId": 797797,
                  "optionText": "Mildly"
                }
              ],
              "answer": {
                "answerId": 803153,
                "questionId": 797720,
                "answerText": null,
                "hasOption": true,
                "answerOption": [
                  {
                    "answerOptionId": 802173,
                    "optionText": "Mildly",
                    "optionId": 797797
                  }
                ]
              }
            },
            {
              "questionId": 797721,
              "questionText": "If Yes, What type of pain are you experiencing?",
              "required": false,
              "questionOrder": 2,
              "weightage": 2.00,
              "inputTypeId": 766103,
              "inputTypeName": "Checkbox",
              "domainId": 768800,
              "isDefault": false,
              "options": [
                {
                  "optionId": 797798,
                  "optionText": "Headache"
                },
                {
                  "optionId": 797799,
                  "optionText": "Muscle pain"
                },
                {
                  "optionId": 797800,
                  "optionText": "Joint pain"
                },
                {
                  "optionId": 798351,
                  "optionText": "Abdominal pain"
                },
                {
                  "optionId": 798352,
                  "optionText": "Nerve pain"
                }
              ],
              "answer": {
                "answerId": 803154,
                "questionId": 797721,
                "answerText": null,
                "hasOption": true,
                "answerOption": [
                  {
                    "answerOptionId": 802174,
                    "optionText": "Muscle pain",
                    "optionId": 797799
                  }
                ]
              }
            },
            {
              "questionId": 797722,
              "questionText": "Do you have someone to help you with daily tasks or emotional support?",
              "required": false,
              "questionOrder": 1,
              "weightage": 2.00,
              "inputTypeId": 766101,
              "inputTypeName": "Short Answer",
              "domainId": 768850,
              "isDefault": false,
              "options": null,
              "answer": {
                "answerId": 803155,
                "questionId": 797722,
                "answerText": "Yes",
                "hasOption": false,
                "answerOption": []
              }
            }
          ]
        },
        "patientContactId": 788262,
        "taskId": 802273
      }
    };
  }
  componentDidMount() {
    console.log("this.props.taskId", this.props.taskId);
    this.fetchSubmittedSurvey()

  }
  async fetchSubmittedSurvey() {
    this.state.spinner.removeAttribute("hidden", "true");

    let showNotification = {};
    const apiUrl = ` ${apiPath.GetAllSubmittedSurvey}?taskId=${this.props.taskId}`; // <-- your API endpoint

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: generalAuthTokenHeader(),
      });

      if (response.status === 400) {
        showNotification = { title: "Submitted Survey", message: "Bad Request", type: "danger" };
      } else if (response.status === 401) {
        userService.logout();
        window.location.reload(true);
      } else if (!response.ok) {
        showNotification = { title: "Submitted Survey", message: "Error fetching data", type: "danger" };
      }

      const data = await response.json();
      console.log("SubmittedSurvey Fetched: ", data);
      console.log("SubmittedSurvey: ", response.data);

      this.setState({ surveyData: data }); // <-- update surveys from API

      if (showNotification.title) userService.showNotification(showNotification);
    } catch (error) {
      console.error("Error fetching input types", error);
      showNotification = { title: "Input Types", message: "Server Error", type: "danger" };
      userService.showNotification(showNotification);
    }

    this.state.spinner.setAttribute("hidden", "true");
  }
  renderQuestion = (q, index) => {
    const baseLabel = (
      <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
        {index + 1}. {q.questionText}
        {q.required && <span style={{ color: 'red' }}> *</span>}
        {q.weightage && <span style={{ fontSize: '0.9rem', color: '#888', marginLeft: '8px' }}>(Weightage: {q.weightage})</span>}
      </label>
    );

    // Get the submitted answer(s) for this question
    const answerOptions = q.answer?.answerOption || [];
    const answerText = q.answer?.answerText;

    if (q.inputTypeName === 'Multiple Choice') {
      return (
        <div key={q.questionId} style={{
          marginBottom: '1.5rem',
          padding: '1rem',
          border: '1px solid #e0e0e0',
          borderRadius: '6px'
        }}>
          {baseLabel}

          <div style={{ marginLeft: '16px' }}>
            {q.options.map(opt => (
              <div key={opt.optionId} style={{ margin: '6px 0', display: 'flex', alignItems: 'center' }}>
                <div style={{
                  width: '18px',
                  height: '18px',
                  borderRadius: '50%',
                  border: '2px solid #666',
                  marginRight: '8px',
                  position: 'relative',
                  backgroundColor: answerOptions.some(a => a.optionId === opt.optionId) ? '#1890ff' : 'transparent'
                }}>
                  {answerOptions.some(a => a.optionId === opt.optionId) && (
                    <div style={{
                      position: 'absolute',
                      top: '3px',
                      left: '3px',
                      width: '8px',
                      height: '8px',
                      borderRadius: '50%',
                      backgroundColor: 'white'
                    }}></div>
                  )}
                </div>
                <span style={{
                  color: answerOptions.some(a => a.optionId === opt.optionId) ? '#1890ff' : 'inherit',
                  fontWeight: answerOptions.some(a => a.optionId === opt.optionId) ? '500' : 'normal'
                }}>
                  {opt.optionText}
                </span>
              </div>
            ))}
          </div>
        </div>
      );
    }

    if (q.inputTypeName === 'Checkbox') {
      return (
        <div key={q.questionId} style={{
          marginBottom: '1.5rem',
          padding: '1rem',
          border: '1px solid #e0e0e0',
          borderRadius: '6px'
        }}>
          {baseLabel}

          <div style={{ marginLeft: '16px' }}>
            {q.options.map(opt => (
              <div key={opt.optionId} style={{ margin: '6px 0', display: 'flex', alignItems: 'center' }}>
                <div style={{
                  width: '18px',
                  height: '18px',
                  border: '2px solid #666',
                  marginRight: '8px',
                  position: 'relative',
                  backgroundColor: answerOptions.some(a => a.optionId === opt.optionId) ? '#1890ff' : 'transparent'
                }}>
                  {answerOptions.some(a => a.optionId === opt.optionId) && (
                    <div style={{
                      position: 'absolute',
                      top: '1px',
                      left: '4px',
                      width: '6px',
                      height: '10px',
                      border: 'solid white',
                      borderWidth: '0 2px 2px 0',
                      transform: 'rotate(45deg)'
                    }}></div>
                  )}
                </div>
                <span style={{
                  color: answerOptions.some(a => a.optionId === opt.optionId) ? '#1890ff' : 'inherit',
                  fontWeight: answerOptions.some(a => a.optionId === opt.optionId) ? '500' : 'normal'
                }}>
                  {opt.optionText}
                </span>
              </div>
            ))}
          </div>
        </div>
      );
    }

    if (q.inputTypeName === 'Rating') {
      return (
        <div key={q.questionId} style={{
          marginBottom: '1.5rem',
          padding: '1rem',
          border: '1px solid #e0e0e0',
          borderRadius: '6px'
        }}>
          {baseLabel}

          <div style={{ marginLeft: '16px', marginTop: '8px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <span style={{ fontSize: '0.9rem', color: '#666' }}>Poor</span>
              {q.options.map(opt => (
                <div key={opt.optionId} style={{
                  width: '32px',
                  height: '32px',
                  borderRadius: '50%',
                  border: '2px solid',
                  borderColor: answerOptions.some(a => a.optionId === opt.optionId) ? '#1890ff' : '#ddd',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: answerOptions.some(a => a.optionId === opt.optionId) ? '#1890ff' : 'transparent',
                  color: answerOptions.some(a => a.optionId === opt.optionId) ? 'white' : '#666',
                  fontWeight: '500'
                }}>
                  {opt.optionText}
                </div>
              ))}
              <span style={{ fontSize: '0.9rem', color: '#666' }}>Excellent</span>
            </div>

            {answerOptions.length > 0 && (
              <div style={{ marginTop: '8px', color: '#1890ff', fontWeight: '500' }}>
                Selected: {answerOptions[0].optionText}
              </div>
            )}
          </div>
        </div>
      );
    }

    // Default to text input for other types
    return (
      <div key={q.questionId} style={{
        marginBottom: '1.5rem',
        padding: '1rem',
        border: '1px solid #e0e0e0',
        borderRadius: '6px'
      }}>
        {baseLabel}

        <div style={{
          marginLeft: '16px',
          marginTop: '8px',
          padding: '8px',
          border: '1px solid #e0e0e0',
          borderRadius: '4px',
          backgroundColor: '#f9f9f9'
        }}>
          {answerText || 'No answer provided'}
        </div>
      </div>
    );
  };

  pacificFormatBackendDate = (dateStr, format = "MM/dd/yyyy hh:mm:ss a") => {
    if (!dateStr) return "";

    let dateObj;

    // Convert input into Date object
    if (dateStr instanceof Date) {
      dateObj = dateStr;
    } else {
      dateObj = new Date(dateStr);
      if (isNaN(dateObj)) return "";
    }

    // Convert to Pacific Time using Intl.DateTimeFormat
    const pacificFormatter = new Intl.DateTimeFormat("en-US", {
      timeZone: "America/Los_Angeles",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });

    // Extract all parts
    const parts = pacificFormatter.formatToParts(dateObj);
    const getPart = (type) => parts.find((p) => p.type === type)?.value || "";

    const month = getPart("month");
    const day = getPart("day");
    const year = getPart("year");
    const hour = getPart("hour");
    const minute = getPart("minute");
    const second = getPart("second");
    const ampm = getPart("dayPeriod");

    // Format output based on requested format
    if (format === "yyyy-MM-dd hh:mm:ss a") return `${year}-${month}-${day} ${hour}:${minute}:${second} ${ampm}`;
    if (format === "MM/dd/yyyy hh:mm:ss a") return `${month}/${day}/${year} ${hour}:${minute}:${second} ${ampm}`;
    if (format === "dd/MM/yyyy hh:mm:ss a") return `${day}/${month}/${year} ${hour}:${minute}:${second} ${ampm}`;


    console.log("pacific date time", `${month}/${day}/${year} ${hour}:${minute}:${second} ${ampm}`);
    // Default fallback
    return `${month}/${day}/${year} ${hour}:${minute}:${second} ${ampm}`;

  };


  render() {
    const { showSurvey, surveyData, submitted, loading, error } = this.state;

    if (loading) return <div>Loading survey...</div>;
    if (error) return <div style={{ color: 'red' }}>Error: {error}</div>;

    return (
      <div style={{
        maxWidth: 700,
        margin: 'auto',
        backgroundColor: '#fff',
        padding: '2rem',
        borderRadius: '8px',
        boxShadow: '0 2px 12px rgba(0, 0, 0, 0.08)'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
          <img src={logo} width="200" alt="MAX MRJ" style={{ marginBottom: '1rem' }} />
          <h2 style={{ color: '#00A9A5', margin: '0.5rem 0' }}>{surveyData.surveyForm.title}</h2>
          <p style={{ color: '#666', margin: '0' }}>{surveyData.surveyForm.description}</p>
        </div>

        <div style={{
          backgroundColor: '#f0f8ff',
          padding: '1rem',
          borderRadius: '6px',
          marginBottom: '1.5rem',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <div>
            <strong>Submitted on:</strong> 
            {/* {new Date(surveyData.submittedAt).toLocaleString()} */}
            {surveyData?.submittedAt ? this.pacificFormatBackendDate(surveyData.submittedAt,"MM/dd/yyyy hh:mm:ss a") : "-"}
          </div>
          {/* <div>
              <strong>Response ID:</strong> {surveyData.formResponseId}
            </div> */}
        </div>

        {showSurvey && surveyData.surveyForm.questions.map((q, i) => this.renderQuestion(q, i))}

        {/* {submitted && (
            <div style={{ 
              marginTop: '2rem', 
              padding: '1rem',
              backgroundColor: '#f0fff0',
              borderRadius: '6px',
              textAlign: 'center',
              border: '1px solid #d6e9c6'
            }}>
               <p style={{ 
                fontWeight: '500', 
                color: '#3c763d',
                margin: '0'
              }}
                 {surveyData.surveyForm.endText || 'Thank you for your response!'} 
              </p> 
            </div>
          )} */}
      </div>
    );
  }
}

export default PreviewSubmittedSurvey;